import "./OKWizardSummaryPassport.scss";

// @vendors
import React from "react";
import PropTypes from "prop-types";

// @helpers
import { i18n } from "core/i18n";
const { FormattedText, formatText } = i18n;

// @components
import { OKSectionBox } from "commonsComponents/OKSectionBox";
const {
    CommercialAds
} = require("components/commons/commercialAds/commercialAds");

const OKSummaryHireCardPassport = ({
    ngos,
    minAmount,
    maxAmount,
    cardType,
    selectedAccount,
    immCard
}) => {
    const buildImageContent = () => {
        return (
            <div className="ok-summary-hire-card-passport__image-container">
                <CommercialAds path="cards" type="cards" immCard={immCard} />
            </div>
        );
    };

    const buildCardModified = () => {
        return (
            <div className="ok-summary-hire-card-passport__info-container">
                <FormattedText
                    value="confirmationSolidarityCard-modifiedCard"
                    className="ok-summary-hire-card-passport__info-container-title"
                />
                <p className="ok-summary-hire-card-passport__info-container-text">
                    {cardType}
                </p>
            </div>
        );
    };

    const buildAssociatedAccount = () => {
        return (
            <div className="ok-summary-hire-card-passport__info-container">
                <FormattedText
                    value="confirmationSolidarityCard-associatedAccount"
                    className="ok-summary-hire-card-passport__info-container-title"
                />
                <p className="ok-summary-hire-card-passport__info-container-text">
                    {selectedAccount}
                </p>
            </div>
        );
    };

    const buildNGOContent = () => {
        const NGOList = ngos
            ? ngos.map((ngo, index) => {
                  return <li key={index}>{ngo.name}</li>;
              })
            : null;

        return (
            <div className="ok-summary-hire-card-passport__info-container">
                <FormattedText
                    value="confirmationSolidarityCard-selectedNGOsConfirmation"
                    className="ok-summary-hire-card-passport__info-container-title"
                />
                <ul className="ok-summary-hire-card-passport__info-container-list">
                    {NGOList}
                </ul>
            </div>
        );
    };

    const buildNGOCardLimits = () => {
        const month = formatText("common-month").toLowerCase();
        const limitlessAmount = formatText(
            "confirmationSolidarityCard-limitlessAmount"
        );
        const textMaxAmount =
            maxAmount === 99999999
                ? limitlessAmount
                : `${maxAmount} €/${month}`;
        return (
            <div className="ok-summary-hire-card-passport__info-container">
                <FormattedText value="common-minimumLimit" />
                <div className="ok-summary-hire-card-passport__info-container-text">
                    {`${minAmount} €/`}
                    <FormattedText value="common-month" format="lowercase" />
                </div>
                <FormattedText value="common-maximumLimit" />
                <div className="ok-summary-hire-card-passport__info-container-text">
                    {`${textMaxAmount}`}
                </div>
            </div>
        );
    };

    const imageContent = buildImageContent();
    const cardModified = buildCardModified();
    const associatedAccount = buildAssociatedAccount();
    const NGOContent = buildNGOContent();
    const NGOCardLimits = buildNGOCardLimits();

    return (
        <OKSectionBox className="ok-summary-hire-card-passport">
            <div className="ok-summary-hire-card-passport__container">
                <h3 className="ok-summary-hire-card-passport__title">
                    <FormattedText value="hireCardSidebar-title" />
                </h3>
                <div className="ok-summary-hire-card-passport__card-data">
                    {imageContent}
                    {cardModified}
                    {associatedAccount}
                </div>
                <div className="ok-summary-hire-card-passport__ngos-data">
                    {NGOContent}
                    {NGOCardLimits}
                </div>
            </div>
        </OKSectionBox>
    );
};

OKSummaryHireCardPassport.propTypes = {
    cardType: PropTypes.string,
    ngos: PropTypes.object,
    minAmount: PropTypes.number,
    maxAmount: PropTypes.number,
    selectedAccount: PropTypes.string,
    selectedImageId: PropTypes.string,
    imagesById: PropTypes.object,
    immCard: PropTypes.object
};

export default { OKSummaryHireCardPassport };
